/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-03 09:41:19
 */
import Vue from 'vue';
import router from './index';
import store from '../store';
import { getStorage } from '@/tools/storage';
import { getToken } from '@/tools/auth'; // getToken from cookie
import { needIdPath } from '@/config/staticData.js';
// import { checkCurrentRoute as checkAccountStatus } from './service/getAccountStatus';
import projectSettledGuide from '@/page/settlementCenter/projectSettled/router.js';
import syncData from './sync-data';

const whiteList = ['/login']; // 白名单

function commitCache() {
  const menus = getStorage('menus');
  const user = getStorage('user');
  store.commit('SET_MENUS', menus);
  store.commit('SET_USER', user);
}

async function guide(next, store, to) {
  await syncData(to);

  // 需要项目信息页面同步到store中
  if (
    (needIdPath.indexOf(to.name) + 1 || /record/.test(to.path)) &&
    !store.state.homeProject.projectType
  ) {
    await store.dispatch('syncProjectInfo', to.query);
    next();
    return;
  }
  //子账号进入概要重定向到项目结算管理页
  let user = getStorage('user') || {};
  if (+user.isMainAccountNumber === 0) {
    if (to.path === '/account/index') {
      // 如果是子账号
      // next({
      //   path: '/projectSettled/list'
      // });
      location.href = router.resolve({
        path: '/projectSettled/list'
      }).href;
      // location.reload(); // 防止概要active状态，简易处理方式
      return;
    }
  }
  next();
}
router.beforeEach((to, from, next) => {
  // TODO: 暂时解决v3跳转v3后，from为undefined。导致后退时to，为undefined。并且v3 路由多次调用。v2跳转v3不会出现这个情况
  if (to.path === '/undefined' && from.path === '/v3/bi-tmpl/bi-tmpl-detail') {
    next({
      name: 'bi-tmpl-list'
    });
    return;
  }
  if (!to.matched.length) {
    next({
      name: 'login'
    });
    return;
  }
  document.title = to.meta.name || '后台管理';
  projectSettledGuide(store, to);
  // breadcrumb(to, store)
  if (getToken() && getStorage('user')) {
    guide(next, store, to);
  } else {
    if (~whiteList.indexOf(to.path)) {
      //在免登录白名单，直接进入
      next();
    } else {
      localStorage.clear();
      next({
        path: '/login'
      });
    }
  }
  commitCache();
});

router.afterEach((to, from) => {
  const obj = {
    shence_id: '',
    frompage_name: from.meta.name || '',
    frompage_url: from.fullPath,
    currentpage_name: to.meta.name || '',
    currentpage_url: to.fullPath
  };
  try {
    const { id: userId } = getStorage('user'); // 用户规则
    obj.shence_id = `asp_${userId}`;
    Vue.prototype.$sa.login(userId);
  } catch (e) {
    window.sa.logout(true);
  }
  // 神策公共属性
  Vue.prototype.$sa.registerPage(obj);
  // 浏览轨迹
  Vue.prototype.$sa.re_pageview();
});
